// extracted by mini-css-extract-plugin
export default {"searchForm":"bw_gL"};